<template>
	<div class="textarea textarea--basic-standard">
		<slot name="label" :id="id" :label="label" :labelHidden="labelHidden">
			<label
				v-if="label"
				:for="id"
				class="textarea__label"
				:class="{ 'visually-hidden': labelHidden }"
			>
				{{ label }}
			</label>
		</slot>
		<textarea
			:id="id"
			v-bind="$attrs"
			v-on="{
				...$listeners,
				input: (e) => $emit('input', e.target.value)
			}"
			:value="value"
			class="textarea__input textarea__input--basic-standard"
			:class="[
				customInputClasses,
				{
					'-disabled': isDisabled,
					'-error': error
				}
			]"
			:disabled="isDisabled"
			:style="style"
		/>
		<div
			class="validation-container"
			:style="`min-height: ${validationFixedHeight}`"
		>
			<ValidationErrors
				class="textarea__validation_errors"
				v-show="error"
				:errors="errorMessages"
			/>
		</div>
	</div>
</template>

<script>
import { ValidationErrors } from "./base";
import { input, label, style } from "./mixins";

/**
 * A standard textarea component.
 */
export default {
	name: "StandardTextarea",

	mixins: [input, label, style],

	components: {
		ValidationErrors
	}
};
</script>

<style scoped>
.textarea__input {
	padding: 18px 18px 14px 18px;
	font-family: inherit;
	font-size: inherit;
	color: inherit;
	line-height: inherit;
}
</style>
